module.exports = __webpack_public_path__ + "static/media/DSA PHONO III.7e6162ff.png";